import React, { useState } from 'react'
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

function Tab() {
    const [TabCheck, SetTabCheck] = useState(false)
    const onClickCangeTab = () => {
        SetTabCheck(!TabCheck);
    }

    return (
        <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
                <div class="card-header" id="heading1">
                    <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                            <button> POST </button> /agWalletAPI/v2/agg/3  {TabCheck ? <FaAngleUp /> : <FaAngleDown />} </div>
                    </h5>
                </div>
                {
                    TabCheck &&
                    <div>
                        <br />
                        <div class="card-body">
                            <p class="mb-0">Production server (uses live data)</p>
                            <div class="api-div-bor">
                                <span>https://payout.safexpay.com</span><span
                                    class="col-org">/agWalletAPI/v2/agg/3</span>
                            </div>
                            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                            <div class="api-div-bor">
                                <span>https://disbursaltwo.safexpay.com</span><span
                                    class="col-org">/agWalletAPI/v2/agg/3</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default Tab